import { useRouteError } from 'react-router-dom';
import { RefreshCcw } from 'lucide-react';
import { Button } from '@heroui/react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { MdArrowBackIos } from 'react-icons/md';
import { getTracerModules } from '@apptracer/sdk';

const ErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const tracer = getTracerModules().error;

  let errorMessage: string;

  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    errorMessage = 'Unknown error occurred';
  }

  const reloadPage = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('t', Date.now().toString());
    window.location.href = url.toString();
  };

  const goToHome = () => {
    navigate('/');
  };

  useEffect(() => {
    tracer?.error(error);
  }, [error]);

  return (
    <section className="flex flex-col gap-2 p-6">
      <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <span className="text-4xl mb-3">⚠️</span>
      </div>
      <h1 className="text-2xl font-bol mb-4">Oops! Something went wrong</h1>

      {error instanceof Error && (
        <p className="text-sm text-gray-500 mb-2">Error name: {error.name}</p>
      )}

      <small>{errorMessage}</small>
      <a href="mailto:support@cyberkoala.ru" className="text-xs text-blue-500 hover:text-blue-400">support@cyberkoala.ru</a>

      <div className="flex gap-4 justify-center">
        <Button onPress={goToHome} color="secondary" className="flex flex-row gap-2">
          <MdArrowBackIos />
          <span>Go back</span>
        </Button>
        <Button onPress={reloadPage} size="md" color="primary" className="flex flex-row gap-2">
          <RefreshCcw />
          <span>Reload</span>
        </Button>
      </div>
    </section>
  );
};

export default ErrorBoundary;
